import { RouteObject } from 'react-router-dom';
import { loadable } from '@sib/ui';
import { paths } from '@spendbrain/config/paths';

export const routes: RouteObject[] = [
  {
    path: paths.reports.root,
    element: loadable(() => import('./pages/ReportsPage')),
  },
  {
    path: paths.reports.tab,
    element: loadable(() => import('./pages/ReportsPage')),
  },
];
